import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimeNgModule } from '../../shared/primeng.module';
import { DataTableComponent } from '../../shared/components/data-table/data-table.component';
import { EquipmentComponent } from './equipment/equipment.component';
import { SystemComponent } from './system/system.component';
import { UserComponent } from './user/user.component';
import { SchemeComponent } from './scheme/scheme.component';
import { SharedModule } from '../../shared/shared.module';
// import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { AccordionModule } from 'primeng/accordion';
import { ProposalComponent } from './proposal/proposal.component';
import { KmpComponent } from './kmp/kmp.component';
import { UnitComponent } from './unit/unit.component';
import { FundComponent } from './fund/fund.component';
import { HasPermissionPipe } from '../../shared/has-permission.pipe';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { UploadModule } from "../../modal/upload/upload.module";
import { TechnologyDomainComponent } from './technology-domain/technology-domain.component';
import { CfiMasterComponent } from './cfi-master/cfi-master.component';
import { NotificationTemplateComponent } from './notification-template/notification-template.component';
  // import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
@NgModule({
  declarations: [
    CfiMasterComponent,
    EquipmentComponent,
    SchemeComponent,
    SystemComponent,
    UserComponent,
    ProposalComponent ,
    KmpComponent,
    UnitComponent,
    FundComponent,
    TechnologyDomainComponent,
    NotificationTemplateComponent
  ],
  imports: [
    AccordionModule,
    CommonModule,
    FormsModule,
    PrimeNgModule,
    // CKEditorModule,
    ReactiveFormsModule,
    SharedModule,
    HasPermissionPipe,
    DragDropModule,
    UploadModule
],
 
})
export class MasterModule { } 